import { Injectable } from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';


@Injectable({
  providedIn: 'root'
})
export class CurrentUserService extends BaseService {
  readonly prefixUrl =  UrlConstant.CURRENT_USER.PREFIX;

  getMenus(type:number) {
    return this.get(this.prefixUrl + UrlConstant.CURRENT_USER.MENUS, {params: {menuType: type}});
  }

  canAccessMenu(menuCode: string) {
    return this.post(this.prefixUrl + UrlConstant.CURRENT_USER.CAN_ACCESS_MENU, menuCode );
  }

  getProfile() {
    return this.get(this.prefixUrl + UrlConstant.CURRENT_USER.PROFILE );
  }

  getSites() {
    return this.get(this.prefixUrl + UrlConstant.CURRENT_USER.SITES);
  }
}
